/**
 * Guitar chord fingering data.
 * frets: [6th string, 5th, 4th, 3rd, 2nd, 1st] - -1=muted, 0=open, 1+=fret
 */

export interface ChordFingering {
  frets: number[];
  baseFret?: number;
  barres?: number[];
}

export const CHORD_FINGERINGS: Record<string, ChordFingering> = {
  // Major
  C: { frets: [-1, 3, 2, 0, 1, 0] },
  "C#": { frets: [-1, 4, 3, 1, 2, 1], barres: [1] },
  Db: { frets: [-1, 4, 3, 1, 2, 1], barres: [1] },
  D: { frets: [-1, -1, 0, 2, 3, 2] },
  "D#": { frets: [-1, -1, 1, 3, 4, 3] },
  Eb: { frets: [-1, -1, 1, 3, 4, 3] },
  E: { frets: [0, 2, 2, 1, 0, 0] },
  F: { frets: [1, 3, 3, 2, 1, 1], barres: [1] },
  "F#": { frets: [2, 4, 4, 3, 2, 2], barres: [2] },
  Gb: { frets: [2, 4, 4, 3, 2, 2], barres: [2] },
  G: { frets: [3, 0, 0, 0, 2, 3] },
  "G#": { frets: [4, 1, 1, 1, 3, 4], barres: [1] },
  Ab: { frets: [4, 1, 1, 1, 3, 4], barres: [1] },
  A: { frets: [-1, 0, 2, 2, 2, 0] },
  "A#": { frets: [-1, 1, 3, 3, 3, 1], barres: [1] },
  Bb: { frets: [-1, 1, 3, 3, 3, 1], barres: [1] },
  B: { frets: [-1, 2, 4, 4, 4, 2], barres: [2] },

  // Minor
  Cm: { frets: [-1, 3, 5, 5, 4, 3] },
  "C#m": { frets: [-1, 4, 6, 6, 5, 4] },
  Dm: { frets: [-1, -1, 0, 2, 3, 1] },
  "D#m": { frets: [-1, -1, 1, 3, 4, 2] },
  Em: { frets: [0, 2, 2, 0, 0, 0] },
  Fm: { frets: [1, 3, 3, 1, 1, 1], barres: [1] },
  "F#m": { frets: [2, 4, 4, 2, 2, 2], barres: [2] },
  Gm: { frets: [3, 5, 5, 3, 3, 3], barres: [3] },
  "G#m": { frets: [4, 6, 6, 4, 4, 4], barres: [4] },
  Am: { frets: [-1, 0, 2, 2, 1, 0] },
  "A#m": { frets: [-1, 1, 3, 3, 2, 1] },
  Bm: { frets: [-1, 2, 4, 4, 3, 2], barres: [2] },

  // 7th
  C7: { frets: [-1, 3, 2, 3, 1, 0] },
  D7: { frets: [-1, -1, 0, 2, 1, 2] },
  E7: { frets: [0, 2, 0, 1, 0, 0] },
  F7: { frets: [1, 3, 1, 2, 1, 1], barres: [1] },
  G7: { frets: [3, 0, 0, 0, 2, 1] },
  A7: { frets: [-1, 0, 2, 0, 2, 0] },
  B7: { frets: [-1, 2, 0, 2, 0, 2] },
  Am7: { frets: [-1, 0, 2, 0, 1, 0] },
  Bm7: { frets: [-1, 2, 0, 2, 0, 2] },
  Dm7: { frets: [-1, -1, 0, 2, 1, 1] },
  Em7: { frets: [0, 2, 0, 0, 0, 0] },
  Cm7: { frets: [-1, 3, 5, 3, 4, 3] },
  Fm7: { frets: [1, 3, 1, 1, 1, 1], barres: [1] },
  Gm7: { frets: [3, 5, 3, 3, 3, 3], barres: [3] },

  // maj7
  Cmaj7: { frets: [-1, 3, 2, 0, 0, 0] },
  Dmaj7: { frets: [-1, -1, 0, 2, 2, 2] },
  Emaj7: { frets: [0, 2, 1, 1, 0, 0] },
  Gmaj7: { frets: [3, 0, 0, 0, 2, 2] },
  Amaj7: { frets: [-1, 0, 2, 1, 2, 0] },
  Bmaj7: { frets: [-1, 2, 4, 3, 4, 2] },
};

export function getChordFingering(chordName: string): ChordFingering | null {
  const normalized = chordName.trim();
  return CHORD_FINGERINGS[normalized] ?? null;
}
